import React, { useState,useEffect } from "react";
import { Link,useLocation  } from "react-router-dom";
const Header = ({ isLoggedIn }) => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path ? "active" : "";
    const tutor = JSON.parse(localStorage.getItem("tutor"));
    
    return (
      <header >
          <div className="navbar-area">
            <div className="mobile-responsive-nav">
                <div className="container">
                   <div className="mobile-responsive-menu">
                        <div className="logo">
                            <Link to="/">
                                <img src="assets/images/lms-logo.png" className="logo-one" alt="logo"/>
                                <img src="assets/images/lms-logo.png" className="logo-two" alt="logo" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="desktop-nav nav-area">
                <div className="container-fluid">
                    <nav className="navbar navbar-expand-md navbar-light ">
                        <Link className="navbar-brand" to="/">
                            <img src="assets/images/lms-logo.png" className="logo-one" alt="Logo" />
                            <img src="assets/images/lms-logo.png" className="logo-two" alt="Logo" />
                        </Link>

                     {/*}   <div className="nav-widget-form">
                            <form className="search-form search-form-bg2">
                                <input type="search" className="form-control" placeholder="Search courses" />
                                <button type="submit">
                                    <i className="ri-search-line"></i>
                                </button>
                            </form>
                        </div>

                        <div className="navbar-category">
                            <div className="dropdown category-list-dropdown">
                                <button className="btn dropdown-toggle" type="button" id="dropdownMenuButtoncategory" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className='flaticon-list'></i>
                                    Categories
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButtoncategory">
                                    <a href="courses-details.html" className="nav-link-item">
                                        <i className="flaticon-web-development"></i>
                                        Development
                                    </a>
                                    <a href="courses-details.html">
                                        <i className="flaticon-design"></i>
                                        Web designing
                                    </a>
                                    <a href="courses-details.html">
                                        <i className="flaticon-wellness"></i>
                                        Lifestyle
                                    </a>
                                    <a href="courses-details.html">
                                        <i className="flaticon-heart-beat"></i>
                                        Health & fitness
                                    </a>
                                    <a href="courses-details.html">
                                        <i className="flaticon-folder"></i>
                                        Data science
                                    </a>
                                    <a href="courses-details.html">
                                        <i className="flaticon-user"></i>
                                        Accounting
                                    </a>
                                    <a href="courses-details.html">
                                        <i className="flaticon-camera"></i>
                                        Photography
                                    </a>
                                    <a href="courses-details.html">
                                        <i className="flaticon-corporate"></i>
                                        Marketing
                                    </a>
                                </div>
                            </div>
                        </div> 
                        */}

                        <div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <Link to="/" className={`nav-item ${isActive("/")}`}>
                                        Home 
                                    </Link>                                    
                                </li>
                                <li className="nav-item">
                                    <Link to="/about-us" className={`nav-item ${isActive("/about-us")}`}>
                                        About Us 
                                    </Link>                                    
                                </li>
                            {/*  <li className="nav-item">
                                   <a href="#" className="nav-link dropdown-toggle">
                                        Pages 
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <a href="about.html" className="nav-link">
                                                About Us
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="testimonials.html" className="nav-link">
                                                Testimonials
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="faq.html" className="nav-link">
                                                FAQ
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="cart.html" className="nav-link">
                                                Cart
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="checkout.html" className="nav-link">
                                                Checkout
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="#" className="nav-link dropdown-toggle">
                                                Instructors
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li className="nav-item">
                                                    <a href="instructors.html" className="nav-link">
                                                        Instructors
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="instructors-details.html" className="nav-link">
                                                        Instructors Details
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item">
                                            <a href="pricing.html" className="nav-link">
                                                Pricing Plan 
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="#" className="nav-link dropdown-toggle">
                                                User
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li className="nav-item">
                                                    <a href="signin.html" className="nav-link">
                                                        Sign in 
                                                    </a>
                                                </li>
                                               <li className="nav-item">
                                                    <a href="signup.html" className="nav-link">
                                                        Sign Up
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="forgot-password.html" className="nav-link">
                                                        Forgot Password
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item">
                                            <a href="terms-condition.html" className="nav-link">
                                                Terms & Conditions
                                            </a>
                                        </li>

                                        <li className="nav-item">
                                            <a href="privacy-policy.html" className="nav-link">
                                                Privacy Policy
                                            </a>
                                        </li>

                                        <li className="nav-item">
                                            <a href="404.html" className="nav-link">
                                                404 Page
                                            </a>
                                        </li>
                                        
                                        <li className="nav-item">
                                            <a href="coming-soon.html" className="nav-link">
                                                Coming Soon
                                            </a>
                                        </li>
                                    </ul>
                                </li>*/}

                                <li className="nav-item">
                                    <a href="#" className="nav-link dropdown-toggle">
                                        Courses
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                        <a href="courses.html" className="nav-link">
                                                Courses
                                        </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="courses-list.html" className="nav-link">
                                                Courses List
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="courses-sidebar.html" className="nav-link">
                                                Courses Sidebar
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="courses-details.html" className="nav-link">
                                                Courses Details 
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                            {/*    <li className="nav-item">
                                    <a href="#" className="nav-link dropdown-toggle">
                                        Event
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <a href="event.html" className="nav-link">Event</a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="event-details.html" className="nav-link">Event Details</a>
                                        </li>
                                    </ul>
                                </li>*/}

                                <li className="nav-item">
                                      <a href="#" className="nav-link dropdown-toggle">
                                        Blog                                   </a>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <a href="blog.html" className="nav-link">
                                                Blog Grid
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="blog-2.html" className="nav-link">
                                                Blog Left Sidebar 
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="blog-3.html" className="nav-link">
                                                Blog Right Sidebar 
                                            </a>
                                        </li>
                                       
                                        <li className="nav-item">
                                            <a href="author.html" className="nav-link">
                                                Author
                                            </a>
                                        </li>
                                        
                                        <li className="nav-item">
                                            <a href="categories.html" className="nav-link">
                                                Categories
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="tags.html" className="nav-link">
                                                Tags
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="#" className="nav-link dropdown-toggle">
                                                Single Blog
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li className="nav-item">
                                                    <a href="single-blog-1.html" className="nav-link">
                                                        Default
                                                    </a>
                                                </li>
                                               <li className="nav-item">
                                                    <a href="single-blog-2.html" className="nav-link">
                                                        With Video
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="single-blog-3.html" className="nav-link">
                                                        With Images Slider
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>

                                <li className="nav-item">
                                    <Link to="contact-us" className={`nav-item ${isActive("/contact-us")}`}>
                                        Contact Us
                                    </Link>
                                </li>
                                {isLoggedIn && (                                     
                                <li className="nav-item">
                                <a href="#"><i className="flaticon-user"></i> 
                               &nbsp; {tutor?.name}</a>
                                <ul className="dropdown-menu usermenu">
                                        <li className="nav-item">
                                            <Link to="/manager/dashboard" className="nav-link">
                                             Dashboard
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/manager/dashboard" className="nav-link">
                                              Profile
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/manager/dashboard" className="nav-link">
                                              Change Password
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/logout"  className="nav-link">
                                              Logout
                                            </Link>
                                        </li>
                                        </ul>
                                </li>
                                 )}
                                 {!isLoggedIn && (
                                    <>
                                  <li className="nav-item d-md-none">
                                  <Link to="/login" className="nav-link">
                                      Login
                                  </Link>
                                  </li>
                                  <li className="nav-item  d-md-none">
                                  <Link to="/signup" className="nav-link">
                                      Signup
                                  </Link>
                                  </li>

                                  </>
                                 )}
                            </ul>
                            {!isLoggedIn && (
                            <div className="others-options d-flex align-items-center">
                                <div className="optional-item">
                                    <Link to="/signup" className="default-btn  border-radius-5">Sign Up</Link>
                                </div>
                                <div className="optional-item ms-2">
                                    <Link to="/login" className="default-btn  border-radius-5">Login</Link>
                                </div>
                            </div> 
                            )}
                        </div>
                    </nav>
                </div>
            </div>
           {/*
            <div className="side-nav-responsive">
                <div className="container">
                    <div className="dot-menu">
                        <div className="circle-inner">
                            <div className="circle circle-one"></div>
                            <div className="circle circle-two"></div>
                            <div className="circle circle-three"></div>
                        </div>
                    </div>
                    
                    <div className="container">
                        <div className="side-nav-inner">
                            <div className="side-nav justify-content-center align-items-center">
                                <div className="side-item">
                                    <form className="search-form">
                                        <input type="search" className="form-control" placeholder="Search courses"/>
                                        <button type="submit">
                                            <i className="ri-search-line"></i>
                                        </button>
                                    </form>
                                </div>

                                <div className="side-item">
                                    <Link to="/signup" className="default-btn two">Sign Up</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>*/}
        </div>
      
      </header>
    );
  }
  export default Header;